import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from "@angular/router";
import { NguCarousel,
    NguCarouselDefDirective,
    NguCarouselNextDirective,
    NguCarouselPrevDirective,
    NguItemComponent } from '@ngu/carousel';
import { createCustomElement } from "@angular/elements";
import { MatIconModule } from "@angular/material/icon";
import { RunScriptsDirectiveModule } from '@signature-it/ngx-generic/directives';
import { SocialShareModuleGeneric } from '@signature-it/ngx-generic/components/social-share';
import { PageScrollToTopModuleGeneric } from '@signature-it/ngx-generic/components/page';
import { LangSelectorModuleGeneric } from '@signature-it/ngx-generic/components/languages';
import { EntityCarouselModuleGeneric } from "@signature-it/ngx-entity/components/entity-carousel";
import { EntityTaxonomyModuleGeneric } from "@signature-it/ngx-entity/components/entity-taxonomy";
import { GalleryModuleGeneric} from '@signature-it/ngx-generic/components/gallery';
//import { SearchPageInputModuleGeneric } from "@signature-it/ngx-entity/components/e-search/e-search-page-input";
import { SearchClearResultsModuleGeneric } from "@signature-it/ngx-entity/components/e-search/e-search-clear-results";
// import { TaxonomyMenuModuleGeneric } from "@signature-it/ngx-entity/components/taxonomy-menu";
import {TaxonomySidenavModule,TaxonomySidenavContentModule} from "@signature-it/ngx-entity/components/taxonomy-sidenav";
import { TableOfContentsModule } from "@signature-it/ngx-entity/components/table-of-contents";
import { PageRelatedItemPreviewModuleGeneric } from "@signature-it/ngx-entity/components/page-related-item-preview";
import { CustomPreviewGalleryModule } from "@signature-it/ngx-entity/components/custom-preview-gallery";
import { CustomPreviewCarouselModuleGeneric } from "@signature-it/ngx-entity/components/custom-preview-carousel";
import { CustomPreviewEntityModule } from "@signature-it/ngx-entity/components/custom-preview-entity";
import { EntityBlockComponentGeneric } from './entity-block.component';
import { PageRelatedMediaPreviewModuleGeneric } from '@signature-it/ngx-entity/components/page-related-media-preview';
import {SafePipeModule, ReplaceTokensPipeArrayModule} from "@signature-it/ngx-generic/pipes";
import { DateFormatModule } from '@signature-it/ngx-entity/components/date-format'
import { SwiperjsModule } from '@signature-it/ngx-entity/components/swiperjs'
import {LangFilterModule} from "@signature-it/ngx-entity/components/lang-filter";
import {DeviceFilterModule} from "@signature-it/ngx-entity/components/device-filter";
import {RemoveElementsIfNotAuthenticateUserPipeModule} from '@signature-it/ngx-generic/pipes/remove-elements-if-not-authenticate-user';
import {RemoveModeElementsPipeModule} from '@signature-it/ngx-generic/pipes/remove-mode-elements';
import {ItemPreviewModule} from '@signature-it/ngx-entity/components/item-preview';
@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        NguCarousel,
        NguCarouselDefDirective,
        NguCarouselNextDirective,
        NguCarouselPrevDirective,
        NguItemComponent,
        RunScriptsDirectiveModule,
        EntityCarouselModuleGeneric,
        EntityTaxonomyModuleGeneric,
        SocialShareModuleGeneric,
        GalleryModuleGeneric,
        PageScrollToTopModuleGeneric,
        TableOfContentsModule,
        RemoveElementsIfNotAuthenticateUserPipeModule,
        RemoveModeElementsPipeModule,
        //SearchPageInputModuleGeneric,
        SearchClearResultsModuleGeneric,
        // TaxonomyMenuModuleGeneric,
        TaxonomySidenavModule,
        TaxonomySidenavContentModule,
        PageRelatedItemPreviewModuleGeneric,
        CustomPreviewGalleryModule,
        CustomPreviewEntityModule,
        LangSelectorModuleGeneric,
        MatIconModule,
        PageRelatedMediaPreviewModuleGeneric,
        SafePipeModule,
        DateFormatModule,
        CustomPreviewCarouselModuleGeneric,
        SwiperjsModule,
        ReplaceTokensPipeArrayModule,
        LangFilterModule,
        DeviceFilterModule,
        ItemPreviewModule
    ],
    declarations: [EntityBlockComponentGeneric],
    exports: [EntityBlockComponentGeneric]
})

export class EntityBlockModuleGeneric {
    constructor(private injector: Injector) {
            const EntityBlockComponentGenericComp = createCustomElement(EntityBlockComponentGeneric, {injector});
            !customElements.get('ngx-entity-block') && customElements.define('ngx-entity-block', EntityBlockComponentGenericComp);
    }
}
